import { TServiceResult } from '@shared/helper/t-service-result';
import { ServiceResult } from '@shared/helper/service-result';
import { Observable } from 'rxjs';
import { ShoppingLinkModel } from '@shared/model/shopping-link/shopping-link-model';
import { HttpClient } from '@angular/common/http';
import { LocalRepository } from '@shared/helper/local-repository';
import { HttpBaseService } from './../../base_services/http_base.service';
import { Injectable, inject } from "@angular/core";
import { TermFilterModel } from '@shared/model/categoryAndSearch/term-filter-model';
import { PageList } from '@shared/model/categoryAndSearch/pageList-model';
import { UrlModel } from '@shared/model/urlModels/url-model';

@Injectable({
  providedIn: 'root'
})

export class ShoppingLinkService extends HttpBaseService {

  constructor() {
    const repo = inject(LocalRepository);
    const http = inject(HttpClient);

    super(repo, http, 'v1/ulAggr');
  }

  createShoppingLink(body: ShoppingLinkModel): Observable<TServiceResult<string>> {
    return this.http.post<TServiceResult<string>>(`${this.apiUrl}/Create`, body);
  }

  deleteLink(body: { bookId: string, urlId: string }): Observable<ServiceResult> {
    return this.http.post<ServiceResult>(`${this.apiUrl}/Delete`, body);
  }

  getByBookId(bookId: string, termFilter: TermFilterModel): Observable<TServiceResult<PageList<UrlModel>>> {
    const params = this.ServiceTermFilter(termFilter);
    return this.http.get<TServiceResult<PageList<UrlModel>>>(`${this.apiUrl}/GetByBookId/${bookId}/${params}`);
  }

  getByWorkId(workId: string, termFilter: TermFilterModel): Observable<TServiceResult<PageList<UrlModel>>> {
    const params = this.ServiceTermFilter(termFilter);
    return this.http.get<TServiceResult<PageList<UrlModel>>>(`${this.apiUrl}/GetByWorkId/${workId}/${params}`);
  }

}
